// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1BoIo","emails":"CreateEditClinics_emails__2ikyU","emailTagLabel":"CreateEditClinics_emailTagLabel__m-SH6"};